<template v-if="entitiesLoaded">
    <div style="height: 100%; min-height: 100%;" class="wrap" :style="{'overflow-y':chat_overflow}">
        <div id="js-chat-group-cmp" class="messages-box"
             :style="{'padding-bottom': (textarea.height + 30 * 2) > 108 ? (textarea.height + 30 * 2 + (replyExists ? 60 : 0))+'px' :
             (replyExists ? '168px' : '108px')}"
            @click="hideAttachMenu">
            <slot></slot>

            <svg class="svg" width="0" height="0">
              <clipPath id="media-clip-incomming" clipPathUnits="objectBoundingBox">
                    <path d="M0.113,0 C0.113,0,0.113,0,0.113,0 H0.068 H0.055 H0.01 C0.004,0,0,0.005,0,0.01 C0,0.012,0.001,0.014,0.002,0.016 L0.046,0.084 V0.952 C0.046,0.979,0.066,1,0.092,1 H0.954 C0.979,1,1,0.979,1,0.952 V0.048 C1,0.021,0.979,0,0.954,0 H0.113"></path>
                </clipPath>
            </svg>
            <svg class="svg" width="0" height="0">
                <clipPath id="media-clip-outcomming" clipPathUnits="objectBoundingBox">
                    <path d="M0.887,1 h0.103 a0.01,0.01,0,0,0,0.01,-0.01 c0,-0.002,-0.001,-0.004,-0.002,-0.006 L0.954,0.916 V0.048 c0,-0.027,-0.021,-0.048,-0.046,-0.048 H0.046 C0.021,0,0,0.021,0,0.048 v0.904 c0,0.027,0.021,0.048,0.046,0.048 h0.841"></path>
                </clipPath>
            </svg>

            <infinite-loading
                ref="infiniteLoadingChat"
                @infinite="getMessages"
                spinner="bubbles"
                direction="top">
                <span slot="no-results">{{ trans('no_chat_messages') }}</span>
                <span slot="no-more" v-if="false">{{ trans('no_more_chat_messages') }}</span>
            </infinite-loading>

            <div class="fixed-event-box" v-if="chatMode === 'event' && isMyEvent(event)">
                <div class="img" :style="{'background': `url(${event.photo_small}) no-repeat center / cover`}"></div>
                <div class="col">
                    <div class="event-title">{{ event.title }}</div>
                    <div class="date">{{ event.event_date | formatDate('day-date-short') }}</div>
                </div>
            </div>

            <div v-for="(msg, index) in messages"
                 class="message-box"
                 :id="`msg-${msg.id}`"
                 @touchstart="startTouch(msg,index,$event)"
                 @touchend="endTouch(msg,index,$event)"
                 @touchmove="touchMove(msg,index,$event)"
                 @click="messageClicked(msg,index,$event)"
                 :class="{'selected' : msg.id === selected_message}"
            >
                <div v-if="isNewDay(index)" class="timeline">{{ msg.idate | formatDate('day-date')}}</div>
                <div class="chat-updates" v-if="['joined', 'left'].includes(msg.msg_type)" @click="openUser(msg.user.handle || msg.user.id,msg.id)">
                    <div class="img" 
                        :class="{'is-deleted': !!msg.user.deleted_at}"
                        :style="!msg.user.deleted_at && {'background': `url(${msg.user.photo_small}) no-repeat center / cover`}">
                    </div>
                    <div class="col">
                        <div v-if="msg.user.id === currentUserId" class="username">{{ trans('you') }}</div>
                        <div v-else class="username">{{ msg.user.headline }}</div>
                        <div class="descr">
                          <span v-if="msg.user.id === currentUserId">{{ trans('have') }}</span><span v-else >{{ trans('has') }}</span> {{ trans(msg.msg_type) }}</div>
                        </div>
                    <div class="time">{{ msg.idate | formatDate('hour',currentUser.unit_system) }}</div>
                </div>

                <div v-if="msg.cancelled" class="message removed" v-bind:class="{'outcomming': msg.user_from === currentUser.id, 'incomming': msg.user_from !== currentUser.id}">
                    {{ trans('removed') }}

                    <svg width="33" height="25" fill="none" class="svg-appendix outcomming" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#a)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                        </g>
                        <defs>
                            <clipPath id="a">
                            <path fill="#99F475" d="M0 0h33v25H0z"/>
                            </clipPath>
                        </defs>
                    </svg>

                    <svg width="33" height="25" fill="none" class="svg-appendix incomming" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#a)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                        </g>
                        <defs>
                            <clipPath id="a">
                            <path fill="#242529" d="M0 0h33v25H0z"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>

                <div v-else-if="(msg.msg_type === 'image') && msg.image_id === null && !msg.cancelled" class="message photo removed" v-bind:class="{'outcomming': msg.user_from === currentUser.id, 'incomming': msg.user_from !== currentUser.id}">
                    <span></span>
                </div>
                <div v-else-if="(msg.msg_type === 'video') && msg.video_id === null && !msg.cancelled" class="message video removed" v-bind:class="{'outcomming': msg.user_to == userId, 'incomming': msg.user_to != userId}">
                    <span></span>
                </div>

                <div v-else-if="!msg.cancelled && !['joined', 'left'].includes(msg.msg_type)" class="message  trigger-touch"
                    :class="{'last': isMessageLast(index) || !!msg.failed,
                        'outcomming': msg.user_from === currentUser.id,
                        'incomming': msg.user_from !== currentUser.id,
                        'msg location': msg.msg_type === 'location',
                        'msg photo': msg.msg_type === 'image',
                        'msg video': msg.msg_type === 'video',
                        'has-reply' : msg.reply_message,
                        'press' : message_started_touch_animation === msg.id
                    }">

                  <svg v-if="msg.user_from !== currentUser.id && msg.reply_message && (msg.msg_type === 'image' || msg.msg_type === 'video')" width="33" height="25" fill="none" class="svg-appendix incomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#a)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#242529" d="M0 0h33v25H0z"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <div v-if="msg.reply_message"  @click="findAndscrollToMessage(msg.reply_message.id)" class="reply-on-container trigger-touch">
                    <div class="reply-on-container_title trigger-touch">
                      <span class="reply-on-container_title-headline trigger-touch">{{msg.reply_message.user.headline}}</span>
                      <span class="reply-on-container_title-handle trigger-touch">@{{msg.reply_message.user.handle}}</span>
                    </div>
                    <div class="reply-on-container_message trigger-touch">
                      <div class="trigger-touch" v-if="msg.reply_message.msg_type === 'text'">{{msg.reply_message.message}}</div>
                      <div class="trigger-touch reply-on-container_message-photo" v-else-if="msg.reply_message.msg_type === 'image'" :style="{'background-image': 'url(' + getImagePath(msg.reply_message) + ')' }"></div>
                      <div class="trigger-touch reply-on-container_message-video" v-else-if="msg.reply_message.msg_type === 'video'" :style="{'background': 'url(' + (msg.reply_message.thumbnail_gif || msg.reply_message.thumbnail_img) + ') center / cover' }"></div>
                      <div class="trigger-touch reply-on-container_message-location" v-else-if="msg.reply_message.msg_type === 'location'" :style="{'background-image': 'url(/main/img/icons/message-location-' + (msg.reply_message.user_from === currentUser.id ? 'outcomming' : 'incomming') + '.svg?ver=2)' }"></div>
                    </div>
                  </div>
                    <div v-if="!['joined', 'left'].includes(msg.msg_type)" class="context-menu-icon" :class="{'hide' : msg.id === selected_message}" @click="showContextMenu(msg,index)">
                      <span class="arrow-circle"></span>
                    </div>
<!--                    <div class="close" @click="tryDelete(msg.id)"
                        v-bind:class="{'no-pro': !userIsPro}"
                        v-if="!['joined', 'left'].includes(msg.msg_type) && msg.user_from == currentUser.id">
                    </div>-->

                    <div class="img  trigger-touch"
                        v-if="msg.user_from !== currentUser.id"
                        @click="openUser(msg.user_from,msg.id)"
                        :class="{'is-deleted': !!msg.user.deleted_at}"
                        :style="!msg.user.deleted_at && {'background': `url(${msg.user.photo_small}) no-repeat center / cover`}">
                    </div>

                    <div class="msg  trigger-touch" v-if="msg.msg_type === 'text'">
                        <div class="username"
                            v-if="msg.user_from !== currentUser.id && msg.msg_type === 'text'">
                            {{ msg.user.headline }}
                        </div>
                        <div class="message-text  trigger-touch" style="word-break: break-word;" @click="messageClick($event,msg)">
                            <div v-html="msgText || '&nbsp;'" v-for="msgText in getMsgTextWithLinks(msg.message,msg.links).split('\n')" class="notranslate trigger-touch">
                            </div>
                            <svg width="33" height="25" fill="none" class="svg-appendix outcomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#a)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                    <path fill="#99F475" d="M0 0h33v25H0z"/>
                                    </clipPath>
                                </defs>
                            </svg>

                            <svg width="33" height="25" fill="none" class="svg-appendix incomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#a)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                    <path fill="#242529" d="M0 0h33v25H0z"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>

                    <div class="message-photo  trigger-touch" v-if="msg.msg_type === 'image'"  @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewPhoto(msg)">
                        <div class="img" :style="{'background-image': 'url(' + getImagePath(msg) + ')' }"></div>
                    </div>

                    <div class="message-video  trigger-touch" v-if="msg.msg_type === 'video'" @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewVideo(msg)">
                        <div class="img" :style="{'background': 'url(' + (msg.thumbnail_gif || msg.thumbnail_img) + ') center / cover' }"></div>
                    </div>

                    <div class="message-location  trigger-touch" v-if="msg.msg_type === 'location'" @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewLocation(msg)">
                        <svg width="33" height="25" fill="none" class="svg-appendix outcomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#a)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                            </g>
                            <defs>
                                <clipPath id="a">
                                <path fill="#99F475" d="M0 0h33v25H0z"/>
                                </clipPath>
                            </defs>
                        </svg>

                        <svg width="33" height="25" fill="none" class="svg-appendix incomming" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#a)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                            </g>
                            <defs>
                                <clipPath id="a">
                                <path fill="#242529" d="M0 0h33v25H0z"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>

                    <div class="message-not-delivered" v-if="msg.failed"></div>
                    
                    <div v-if="msg.failed" class="message-not-delivered-text" @click.stop="editMessageForNotDelivered(msg)">
                        {{ trans('message_not_delivered') }}
                    </div>

                    <div v-if="!msg.failed && isMessageLast(index)" class="time">
                        <span v-if="msg.user_to == currentUser.id && userIsPro" v-bind:class="{'is-read': msg.is_read === 'yes'}">
                            <span class="message-info delivered" v-if="msg.is_read !== 'yes'"></span>
                            <span class="message-info read" v-else></span>
                        </span>
                        {{ msg.idate | formatDate('hour',currentUser.unit_system) }}
                    </div>
                </div>
            </div>
        </div>
        <ContextMenu @delete="tryDelete" @copyCallback="copyCallback" @focus="focusMessageField" :chatMode="chatMode" :event="event" :eventId="eventId" :userId="userId" @replyCallback="replyCallback" @hideContextMenu="hideContextMenu" ref="contextMenu" ></ContextMenu>
        <MessageCopiedComponent :isShown="message_copied" :type="message_copied_type"></MessageCopiedComponent>
        <transition name="fade">
            <div v-show="showScrollBottom" class="scroll_bottom-button"
                style="margin-bottom: 10px;"
                :class="{'reply-shown': replyExists,'attach-menu-open': attachMenuVisible, 'send-media-open': tab === 'photo' || tab === 'video', 'photo': tab === 'photo', 'video': tab === 'video', 'send-location-open': tab === 'location'}"
                @click="scrollToBottom()" :title="trans('arrow_scroll_top')">
                <svg class="icon icon-arrow_down"><use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_down')"></use></svg>
            </div>
        </transition>

        <div class="footer" :class="{'reply-shown': replyExists,'attach-menu-open': attachMenuVisible, 'send-media-open': tab === 'photo' || tab === 'video', 'photo': tab === 'photo', 'video': tab === 'video', 'send-location-open': tab === 'location'}"
            @click.self="showTab()">
          <HandlesList @close-handles-list="closeHandlesList" @choose-handle="chooseHandle" v-if="search_handle" :text="search_handle"></HandlesList>
          <Reply v-if="replyExists"
                 :msg="replyExists"
                 :user="replyExists.user_from === currentUser.id ? currentUser : reply_message.user"
                 :interlocutorId="reply_message.user.id"
                 :eventId="eventId"
          ></Reply>
            <div class="inner">
              <div v-if="clipboardImage" class="inner-clipboard">
                <div class="inner-clipboard-close close" @click="clipboardImage = false">

                </div>
                <div class="inner-clipboard-content">
                  <img :src="clipboardImageUrl" @click="showClipBoardImage(clipboardImageUrl)" />
                  <div class="inner-clipboard-content-text">
                    {{trans('copied_from_clipboard')}}
                  </div>
                </div>
              </div>
              <div v-else class="inner-text">
                <div id="attach" class="attach" @click="attachMenuVisible = !attachMenuVisible || showTab()"></div>
                <textarea
                    v-if="isMobile"
                    autofocus
                    id="text__field"
                    @paste="pasteFromClipBoard"
                    :rows="textarea.rows"
                    :placeholder="trans('type_something')"
                    v-model="textarea.message"
                    ref="chatMessageTextarea"
                    @focus="focusTextArea"
                    @keyup="searchHandleCheck"
                    @blur="unfocusTextArea"
                    @input="resizeTextArea"
                    @keydown.delete="deleteTextMessage"
                    @keyup.enter.exact="resizeTextAreaDebounce"
                    @keydown.enter.shift.exact.prevent
                    @keydown.enter.shift.exact="sendMessage"
                    tabindex="1"
                ></textarea>
                <textarea
                    v-if="!isMobile"
                    autofocus
                    @paste="pasteFromClipBoard"
                    id="text__field"
                    :rows="textarea.rows"
                    :placeholder="trans('type_something')"
                    v-model="textarea.message"
                    ref="chatMessageTextarea"
                    @focus="focusTextArea"
                    @blur="unfocusTextArea"
                    @keyup="preventInternationalKeyboardBug"
                    @input="resizeTextArea"
                    @keyup.enter.exact.prevent
                    @keydown.enter.exact.prevent
                    @keydown.enter.exact="sendMessage" 
                    @keydown.enter.shift.exact="resizeTextAreaDebounce"
                    @keydown.delete="deleteTextMessage"
                    tabindex="1"
                ></textarea>
              </div>
              <div v-if="send_message_preloader" class="spinner-container">
                <img class="preloader"
                     src="/assets/img/preloader.svg"
                     alt="">
              </div>
              <div v-else class="send" @click="sendMessage" tabindex="2">
                  <i class="send"></i>
              </div>
            </div>
            <div class="attach-menu" v-show="attachMenuVisible">
                <div class="attach-menu-inner">
                    <div id="send-photo" class="media-link photo" @click="showTab('photo')">
                        <i class="photo"></i>
                    </div>
                    <div id="send-video" class="media-link video" @click="showTab('video')">
                        <i class="video"></i>
                    </div>
                    <div id="send-location" class="media-link location" @click="showTab('location')">
                        <i class="location"></i>
                    </div>
                </div>
            </div>

            <div class="send-media-box" v-show="tab !== null" :class="{'photo': tab === 'photo', 'video': tab === 'video'}">
                <div class="send-media-wrapper" v-show="tab === 'photo'">
                    <div class="close" @click="showTab()"></div>
                    <vue-custom-scrollbar v-if="isDesktop" class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addPhotoButton" class="pic upload-photo" @click="choosePhoto">
                                <input type="file" id="newPhotoUpload" class="show-for-sr" name="photo" accept="image/*" ref="photo" v-on:change="uploadProfilePhoto($event, true)">
                            </div>
                            <div class="pic" v-for="(photo, index) in photos" @click="selectMedia(photo.id, index, 'photo')"
                                :class="{'selected': photo.active}">
                                <img class="img" :src="photo.photo_small" :src-big="photo.photo_orig" :id="`profile-photo-${photo.id}`" alt="" />
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendPhotos">{{ trans('send_photo') }}</button>
                        </div>
                    </vue-custom-scrollbar>
                    <div v-else class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addPhotoButton" class="pic upload-photo" @click="choosePhoto">
                            <input type="file" id="newPhotoUpload" class="show-for-sr" name="photo" accept="image/*" ref="photo" v-on:change="uploadProfilePhoto($event, true)">
                        </div>
                        <div class="pic" v-for="(photo, index) in photos" @click="selectMedia(photo.id, index, 'photo')"
                             :class="{'selected': photo.active}">
                            <img class="img" :src="photo.photo_small" :src-big="photo.photo_orig" :id="`profile-photo-${photo.id}`" alt="" />
                        </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendPhotos">{{ trans('send_photo') }}</button>
                        </div>
                    </div>
                </div>

                <div class="send-media-wrapper" v-show="tab === 'video'">
                    <div class="close" @click="showTab()"></div>
                    <vue-custom-scrollbar v-if="isDesktop" class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addVideoButton" class="pic upload-photo" @click="chooseVideo">
                                <input type="file" id="newVideoUpload" class="show-for-sr" name="video" accept="video/*" ref="video" v-on:change="uploadVideo($event)">
                            </div>
                            <div class="pic" v-for="(video, index) in videos" @click="selectMedia(video.id, index, 'video')"
                                v-if="!!video.id"
                                :class="{'selected': video.active}">
                                <span class="preloader"
                                    :style="{'background': !video.id ? 'url(/assets/img/preloader.svg) center no-repeat' : 'none'}">
                                </span>
                                <div class="img" v-if="!!video.id" :id="`profile-video-${video.id}`"
                                    :style="{'background': `url(${video.thumb_small}) center / cover`}">
                                </div>
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendVideos">{{ trans('send') }}</button>
                        </div>
                    </vue-custom-scrollbar>
                    <div v-else class="send-media-inner">
                      <div class="pics-catalog">
                        <div id="addVideoButton" class="pic upload-photo" @click="chooseVideo">
                          <input type="file" id="newVideoUpload" class="show-for-sr" name="video" accept="video/*" ref="video" v-on:change="uploadVideo($event)">
                        </div>
                        <div class="pic" v-for="(video, index) in videos" @click="selectMedia(video.id, index, 'video')"
                             v-if="!!video.id"
                             :class="{'selected': video.active}">
                                  <span class="preloader"
                                        :style="{'background': !video.id ? 'url(/assets/img/preloader.svg) center no-repeat' : 'none'}">
                                  </span>
                          <div class="img" v-if="!!video.id" :id="`profile-video-${video.id}`"
                               :style="{'background': `url(${video.thumb_small}) center / cover`}">
                          </div>
                        </div>
                      </div>
                      <div class="float-button">
                        <button class="btn" @click="sendVideos">{{ trans('send') }}</button>
                      </div>
                    </div>
                </div>
            </div>

            <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this,'swipeRight')">
                <div class="send-location-box" id="location__tab" v-show="tab === 'location'">
                    <div class="send-location-inner">
                        <div id="map" class="pick-location no-swiping" v-if="!userLoading">
                            <Map
                                :lat="lat"
                                :lng="lng"
                                :zoom="mapZoom"
                                styles="height: 250px"
                                :clickable="true"
                                :draggable="true"
                                :dragEnd="handleMapMarkerDrag"
                                :zoomChanged="handleZoomChanged"
                                ref="geoMap"
                            />
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendLocation">{{ trans('send_location') }}</button>
                        </div>
                    </div>
                </div>
            </vue2-gesture>
        </div>

        <alert v-if="deleteAlertVisible" :small="true" v-on:hide-alert="hideDeleteAlert">
            <p>{{ trans('delete_this_message') }}</p>
            <div class="dialog-actions">
                <button type="button" class="btn darker" @click="hideDeleteAlert">{{ trans('cancel') }}</button>
                <button type="button" class="btn" @click="confirmDelete">{{ trans('delete') }}</button>
            </div>
        </alert>

        <alert v-if="locationPreviewVisible" v-on:hide-alert="hideLocationPreview">
            <Map
                :lat="JSON.parse(locationPreview.message).lat"
                :lng="JSON.parse(locationPreview.message).lng"
                :zoom="JSON.parse(locationPreview.message).zoom"
                :styles="mapStyles"
                :clickable="true"
                :draggable="false"
            />
        </alert>
    </div>
</template>

<style lang="css" scoped>
    @import "../../../_general/lib/slim/slim.min.css";

    .form-error {
        margin-top: 0;
    }
</style>

<script>
    import { mapState, mapGetters } from 'vuex';

    import InfiniteLoading from 'vue-infinite-loading';
    import { scrollToNewMessages } from '@chat/lib/helpers';
    import chatModule from '@chat/module/store/type'
    import eventsModule from '@events/module/store/type'
    import auth from '@general/lib/auth';
    import Alert from '@buddy/views/widgets/Alert.vue';
    import Map from '@buddy/views/widgets/Map.vue';
    import $ from "jquery";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import _ from "lodash";
    import ContextMenu from "../../../buddy/views/widgets/ContextMenu.vue";
    import Reply from "./Reply.vue";
    import MessageCopiedComponent from "../../../buddy/views/widgets/MessageCopiedComponent.vue";
    import HandlesList from "../../../buddy/views/widgets/HandlesList.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-events').default,
            require('@general/lib/mixin-chat').default,
            require('@general/lib/mixin-clubs').default
        ],
        props: ['chatMode', 'userId', 'eventId', 'conversation_id'],
        components: {
          HandlesList,
          MessageCopiedComponent,
          Reply,
            ContextMenu,
            Alert,
            InfiniteLoading,
            Map,
            vueCustomScrollbar
        },
        data(){
            return {
                message_started_touch_animation:false,
                send_message_preloader: false,
                message_copied_timeout: false,
                message_copied:  false,
                message_copied_type: false,
                clipboardImage: false,
                reply_message : false,
                touchstarted: false,
                touchstartedX:null,
                touchMoveDistance: false,
                message_clicked_last_time:false,
                selected_message: null,
                isFirstLoad: true,
                refreshQueued: false,
                chatAllowed: false,
                tab: null,

                selectedPhotos: [],
                selectedVideos: [],

                deleteAlertVisible: false,
                deleteMessageId: 0,
                search_handle: false,
                croppers: [],
                editPhotoId: null,
                slimOptions: this.defaultSlimOptions(),

                textarea: {
                    rows: 1,
                    height: 45,
                    scrollHeight: null,
                    baseScrollHeight: 0,
                    message: ''
                },

                attachMenuVisible: false,

                mask: {
                    initialWidth: 400,
                    initialHeight: 400,
                    widthModifier: 1,
                    heightModifier: 1,
                    width: 0,
                    height: 0,
                },

                locationPreview: null,
                locationPreviewVisible: false,
                lat: 52.520389,
                lng: 13.40424,
                mapZoom: 15,
                showScrollBottom: false,

              currentUserId: auth.getUserId(),
              chat_overflow: 'initial', //needed for fixing scroll issue
              scrollInterval : false
            }
        },
        methods: {
          messageClick(e,msg){
            if(msg.failed) {
              this.editMessageForNotDelivered(msg)
            }else{
              if(e.target.classList.contains('issue_link')){
                this.openLink(e);
              }
            }
          },
          chooseHandle(handle){
            if(this.$refs.chatMessageTextarea) {
              let cursorPosition = this.$refs.chatMessageTextarea.selectionStart
              let text = this.textarea.message.substring(0, cursorPosition)
              let arr = text.split("@")
              arr.pop()
              let link_str = arr.join('@') + '@' + handle;
              this.textarea.message = link_str + ' ' + this.textarea.message.substring(cursorPosition)
              this.$nextTick(() => {
                this.$refs.chatMessageTextarea.selectionStart = link_str.length + 1;
                this.$refs.chatMessageTextarea.selectionEnd = link_str.length + 1;
                this.closeHandlesList()
                this.focusMessageField()
              });
            }
          },
          closeHandlesList(){
            this.search_handle = false;
            this.changeScrollBarState(true)
          },
          searchHandleCheck(){
            if(this.$refs.chatMessageTextarea) {
              let cursorPosition = this.$refs.chatMessageTextarea.selectionStart
              let lines = this.textarea.message.substring(0,cursorPosition).split("\n")
              let words = lines[lines.length - 1].split(" ")
              if (words[words.length - 1].indexOf('@') === 0 && words[words.length - 1].length > 3) {
                this.changeScrollBarState(false)
                this.search_handle = words[words.length - 1]
                return null;
              }
            }

            this.changeScrollBarState(true)
            this.search_handle = false;
          },
          pasteFromClipBoard(e){
            let text = '';
            let self = this;
            if (e.clipboardData || e.originalEvent.clipboardData) {
              if((e.originalEvent || e).clipboardData.files){
                const file = (e.originalEvent || e).clipboardData.files[0];
                self.clipboardImage = file;
              }else{
                text = (e.originalEvent || e).clipboardData.getData('text/plain');
              }
            } else if (window.clipboardData) {
              text = window.clipboardData.getData('Text');
            }
          },
          preventInternationalKeyboardBug(e){
            if(e.code !== 'Enter'){
              //this bug came if choose US international keyboard and set sumbols ˆ,'," at the end of message
              this.$refs.chatMessageTextarea.blur();
              this.$refs.chatMessageTextarea.focus();
              this.searchHandleCheck();
            }
          },
          copyCallback(type){
            this.message_copied_type = type;
            this.message_copied = true;
            this.message_copied_timeout = setTimeout(() => {this.message_copied = false},2000)
          },
          showClipBoardImage(clipboardImageUrl){
            app.$emit('show-clipboard-photo-group', clipboardImageUrl)
          },
          scrollToTop(){
            if (this.isMobile) {
              const scrollElement = this.$el.querySelector('#js-chat-group-cmp').firstElementChild;

              this.$nextTick(() => {
                scrollElement.scrollIntoView({block: "center"})
                window.scrollTo(0,document.body.scrollHeight - visualViewport.height);
              });
            } else {
              const containerName = this.chatMode.toLowerCase();
              const scrollDiv = document.getElementById(`conversation-${containerName}-scroll`);
              if(scrollDiv){
                this.$nextTick(() => {
                  scrollDiv.scroll({
                    top: 0,
                  })
                })
              }
            }
          },
          async scrollToMessage(msg){
            const scrollElement = document.getElementById('msg-'+msg.id);
            if (this.isMobile) {
              this.$nextTick(() => {
                scrollElement.scrollIntoView({block: "center"})
                setTimeout(function (){
                  scrollElement.classList.add("scale");
                  setTimeout(function (){
                    scrollElement.classList.remove("scale");
                  },400)
                },200)
              });
            } else {
              const containerName = this.chatMode.toLowerCase();
              const scrollDiv = document.getElementById(`conversation-${containerName}-scroll`);

              if(scrollDiv){
                this.$nextTick(() => {
                  scrollDiv.scroll({
                    top: scrollElement.offsetTop - ($('.conversation-screen').outerHeight()) / 2 + scrollElement.offsetHeight / 2,
                  })
                  setTimeout(function (){
                    scrollElement.classList.add("scale");
                    setTimeout(function (){
                      scrollElement.classList.remove("scale");
                    },400)
                  },200)
                })
              }
            }
          },
          async findAndscrollToMessage(reply_msg_id){
            if(this.selected_message){
              return false;
            }
            console.log('[scrollToMessage] Started',reply_msg_id)
            let self = this;
            let reply_msg = false;
            if(!this.scrollInterval){
              this.scrollInterval = setInterval(function (){
                $.each(self.messages,function(key,val){
                  if(val.id === reply_msg_id){
                    reply_msg = val;
                  }
                })
                if(!reply_msg){
                  self.scrollToTop();
                }else{
                  self.scrollToMessage(reply_msg)
                  clearInterval(self.scrollInterval);
                  self.scrollInterval = false;
                }
              },100);
            }

          },
          replyOn(msg){
            this.reply_message = msg;
            this.$store.commit(chatModule.mutations.replies.add, {
              userId: this.userId,
              eventId: this.eventId,
              chatMode: this.chatMode,
              msg: msg
            })
          },
          startTouch(msg,index,e){
            $('#msg-'+msg.id).css('position','relative')
            console.log('[startTouch]',e.touches[0].pageX,e.target);
            if(!this.selected_message && e.target.classList.contains('trigger-touch')){
              this.message_started_touch_animation = msg.id;
              this.touchstarted = true;
              this.touchstartedX = e.touches[0].pageX;
              let self = this;
              $('body').css('user-select','none')
              this.touchTimer = setTimeout(function(){
                self.showContextMenu(msg,index)
                setTimeout(function (){
                  $('body').css('user-select','auto')
                },200);
              }, 400);
              if(!navigator.userAgent.match('CriOS')){
                //this.checkDoubleClick(msg,index);
              }
            }
          },
          touchMove(msg,index,e){
            if(!this.selected_message && e.target.classList.contains('trigger-touch')) {
              console.log('[touchMove]', e.touches[0].pageX, e.touches[0].pageX - this.touchstartedX)
              this.message_started_touch_animation = false;
              this.touchMoveDistance = e.touches[0].pageX - this.touchstartedX;
              if(this.touchMoveDistance < -10){
                this.changeScrollBarState(false)
              }
              if (this.touchMoveDistance < 0) {
                $('#msg-' + msg.id).css('left', this.touchMoveDistance + 'px')
              }
              //$('#msg-'+msg.id).css('top',e.touches[0].pageY + 'px')
              if (this.touchTimer) {
                clearTimeout(this.touchTimer);
              }
            }
          },
          endTouch(msg,index,e){
            this.touchstarted = false;
            console.log('[End touch]')
            if(!this.selected_message) {
              this.message_started_touch_animation = false;
              this.changeScrollBarState(true)
              if (this.touchTimer) {
                $('body').css('user-select', 'auto')
                clearTimeout(this.touchTimer);
              }
              if(this.touchMoveDistance < -50){
                this.replyOn(msg);
                this.focusMessageField();
              }
              this.touchMoveDistance = 0;
              $('#msg-'+msg.id).css('left','0')
            }
          },
          replyCallback(msg){
            this.reply_message = msg
          },
          messageClicked(msg,msg_index,e){
            if(e.target.classList.contains('message-box') ||
                e.target.classList.contains('timeline') ){
              this.$refs.contextMenu.hideMenu();
            }else{
              if(navigator.userAgent.match('CriOS')){
                this.checkDoubleClick(msg,msg_index);
              }
            }
          },
          hideContextMenu(){
            this.selected_message = false
            this.changeScrollBarState(true)
          },
          showContextMenu(msg,index){
            if(!msg.id){
              let self = this;
              let conversation_key = 'group' + '_' + this.eventId;
              setTimeout(function (){
                let updated_msg = self.$store.state.chatModule.chat[msg.channel].messages[conversation_key][index]
                self.showContextMenu(updated_msg,index);
              },100)

              return false;
            }
            this.selected_message = msg.id;
            this.message_started_touch_animation = false;
            this.$refs.contextMenu.showMenu(msg);
            this.changeScrollBarState(false)
          },
            async openUser(userId,msg_id){
                app.prevMessageId = msg_id;
                let user = await this.$store.dispatch('loadUserInfo', userId)
                if (!user)
                    return

                if (user.deleted_at) {
                    this.showErrorNotification('profile_is_deleted')
                    return
                }

                if (this.isMobile) {
                    this.goTo('/user/' + userId)
                } else {
                    this.openUserModal(userId)
                }
            },

            // ###############################################
            // General methods
            // ###############################################
            selectMedia(id, index, type) {

              let data, arr;

              if (type === 'photo') {
                data = this.photos[index];
                arr = this.photos;
              } else {
                data = this.videos[index];
                arr = this.videos;
              }

              data.active = !data.active;

              if (!data.active) {
                this.removeByValue(this.selectedPhotos, data.id)
              } else {
                type === 'photo' ? this.selectedPhotos.push(data.id) : this.selectedVideos.push(data.id);
              }

              this.$set(arr, index, data);
            },
            removeByValue(arr) {
              let what, a = arguments, length = a.length, ax;
              while (length > 1 && arr.length) {
                what = a[--length];
                while ((ax = arr.indexOf(what)) !== -1) {
                  arr.splice(ax, 1);
                }
              }
              return arr;
            },
            showAttachMenu() {
                this.attachMenuVisible = true;
            },
            hideAttachMenu() {
                if(this.selected_message){
                  return false;
                }
                this.tab = false;
                this.attachMenuVisible = false;
                this.changeScrollBarState(true)
            },
            init(){
                let v = this

                $('.media-link').on('click', function (e) {
                    e.preventDefault();
                    $('.w-messagebar').addClass('active');
                    $('.w-page__content').on('click', function (e) {
                        $('.w-messagebar').removeClass('active');
                    });
                    $('#text__field').on('click', function (e) {
                        $('.w-messagebar').removeClass('active');
                    });
                });
                $('#keyboard__link').on('click', function (e) {
                    $('#text__field').click().focus();
                });

                let storageId = 'remember-chat-group-' + this.eventId
                if (storageId) {
                    let storedMessage = localStorage.getItem(storageId)
                    if (storedMessage)
                        this.textarea.message = storedMessage
                }

                this.initTextAreaValues();
            },
            async getMessages(infiniteScroll) {
                this.$nextTick(() => {
                  this.chat_overflow = 'hidden'
                })
                console.log('getMessages', {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatMode: this.chatMode,
                    conversationId: this.conversation_id
                })
                this.$store.commit(chatModule.mutations.conversations.deleteCursor, {
                  conversationId: this.conversation_id
                })

                let messages = await this.$store.dispatch(chatModule.actions.messages.loadGroup, {
                    eventId: this.eventId,
                    conversation_id: this.conversation_id
                })

                if (messages.length) {
                    this.chat_overflow = 'initial'
                    infiniteScroll.loaded()
                }
                if (messages.length < window.LOAD_CHAT_MESSAGES_LIMIT) {
                    this.chat_overflow = 'initial'
                    infiniteScroll.complete()
                }

                this.initTextAreaValues()
                //when chat opened and messages loaded
                this.$nextTick(() => {
                  if (this.isFirstLoad) {
                    this.scrollToBottom()
                    this.isFirstLoad = false;
                  }
                });
            },
            scrollToBottom() {
                if (this.isMobile) {
                    const scrollElement = this.$el.querySelector('#js-chat-group-cmp').lastElementChild;

                    this.$nextTick(() => {
                        scrollElement.scrollIntoView({block: "center"})
                    });
                } else {
                    const scrollDiv = document.getElementById('conversation-group-scroll');

                    const lastMessageElem = this.$el.querySelector('#js-chat-group-cmp').lastElementChild;
                    const coordinates = scrollDiv.scrollHeight - lastMessageElem.offsetHeight;

                    this.$nextTick(() => {
                        scrollDiv.scroll({
                            top: coordinates,
                        })
                    })
                }
            },
            isMessageLast(index) {
                const msg = this.messages[index];
                const nextMsg = this.messages[index+1];

                return !nextMsg || msg.user_from != nextMsg.user_from || msg.idate.substr(0, 16) != nextMsg.idate.substr(0, 16);
            },
            getNewMessagePayload(messageFields){
                let event = this.event

                if(this.replyExists){
                  messageFields['reply_message'] = {
                    id: this.replyExists.id,
                    user: {
                      headline: this.reply_message.user.headline,
                      handle: this.reply_message.user.handle
                    },
                    message: this.replyExists.message,
                    msg_type: this.replyExists.msg_type,
                    thumbnail_gif: this.replyExists.thumbnail_gif,
                    thumbnail_img: this.replyExists.thumbnail_img,
                    photo_small : this.replyExists.photo_small,
                    lat : this.replyExists.lat,
                    lng : this.replyExists.lng,
                    zoom : this.replyExists.zoom,
                    user_from: this.replyExists.user_from
                  }
                  this.$store.commit(chatModule.mutations.replies.remove, {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatMode:this.chatMode
                  })
                }
                let payload = {
                    eventId: this.eventId,
                    conversation: {
                        chatType: 'group',
                        message: {
                            hash: null,
                            id: null,
                            idate: moment().utc(),
                            image_id: null,
                            video_id: null,
                            cancelled: false,
                            message: null,
                            msg_type: null,
                            user_from: auth.getUserId(),
                            channel: 'group',
                            ...messageFields
                        },
                        unreadMessagesCount: 0
                    },
                    isNewUnreadMessage: false,
                    insertIfMissing: true
                }

                payload.conversation.event = {
                    id:          event.id,
                    date:        event.event_date,
                    photo_small: event.photo_small,
                    title:       event.title
                }
                payload.conversation.message.event_id = event.id

                return payload
            },

            async sendMessage(e) {
                if (e) {
                    e.preventDefault();
                }
                
                if (this.userIsInactive) {
                    return;
                }

                if(this.clipboardImage){
                  let self = this;
                  this.send_message_preloader = true;
                  app.$on('photo-added-event', function(photo){
                    app.$off('photo-added-event');
                    self.selectedPhotos = [photo.id]
                    self.sendPhotos();
                    self.clipboardImage = false;
                    self.send_message_preloader = false;
                  });
                  this.uploadProfilePhoto({target:{files:[this.clipboardImage]}}, true)
                  return;
                }
                let message = this.textarea.message.replace(/^\s+|\s+$/g, ''); //trim whitespace from the beginning and ending of string
                let msg_with_links = message;
                //change links in text
                //this done so "hard" coz need to handle a lot of edge cases, if you know how to do this easy, please do it
                let regex = {
                  ' ' : ' ',
                  '^' : '',
                  '\n' : '\n'
                };
                $.each(regex,function(reg_key,reg_val){
                  let links_in_text = message.match(new RegExp('('+reg_key+')@[a-zA-Z0-9\-_.]+', "g"));
                  $.each(links_in_text, function (key,link){
                    let re = new RegExp((reg_val === '' ? reg_key : '') + link, "g");
                    link = link.replace(reg_val,'')
                    msg_with_links = msg_with_links.replace(re, reg_val + '<span class="issue_link trigger-touch">'+link+'</span>');
                  });
                })
                if (message) {
                    this.textarea.message = ''
                    // We need temporary hash to match and update this message later
                    let messageHash = Math.random().toString(36)


                  let conversationUpdatePayload = this.getNewMessagePayload({
                        msg_type: 'text',
                        message:  message,
                        hash: messageHash
                    })

                    this.$store.dispatch(chatModule.actions.conversations.update, conversationUpdatePayload)

                    this.$store.commit(chatModule.mutations.message.push, {
                        eventId: this.eventId,
                        message: {
                            ...conversationUpdatePayload.conversation.message,
                            hash: messageHash,
                            message: msg_with_links
                        }
                    })

                    this.$nextTick(function(){
                        this.scrollToBottom();
                    })
                    try {
                        let response = await axios.post('/api/sendMessage', {
                            eventId: this.eventId,
                            message: message,
                            msgType: 'text',
                            conversationId: this.conversation_id,
                            channel: 'group',
                            hash:    messageHash,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                              conversationUpdatePayload.conversation.message.reply_message.id : null,
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                    eventId: this.eventId,
                                    conversation: data.conversation,
                                    isNewUnreadMessage: false,
                                    insertIfMissing: true
                                })

                                let message = {...data.conversation.message, hash: messageHash }
                                this.$store.commit(chatModule.mutations.message.update, {
                                    eventId: this.eventId,
                                    message
                                })

                                this.$nextTick(function(){
                                    this.scrollToBottom();
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e)
                        this.$store.commit(chatModule.mutations.message.update, {
                            eventId: this.eventId,
                            message: {
                                ...conversationUpdatePayload.conversation.message,
                                hash: messageHash,
                                id: messageHash,
                                failed: true,
                            }
                        })

                        this.$nextTick(function(){
                            this.scrollToBottom();
                        })
                    }
                    
                }

                let storageId = 'remember-chat-group-' + this.eventId
                if (storageId) {
                    localStorage.setItem(storageId, '')
                }

                this.$nextTick(function(){
                    this.afterSend()
                })
            },
            
            editMessageForNotDelivered(failedMessage) {
                this.$store.commit(chatModule.mutations.messages.set, {
                    userId: this.userId,
                    eventId: this.eventId,
                    messages: this.messages.filter(message => message.id !== failedMessage.id)
                })

                switch (failedMessage.msg_type) {
                    case 'text':
                        this.textarea.message = failedMessage.message
                        this.$nextTick(function(){
                            this.focusMessageField()
                            if (app.isDesktop) {
                                this.changeScrollStyle(false, true)
                                this.changeScrollStyle(true, false)
                            }
                        })
                        break;
                    case 'image':
                        this.showAttachMenu()
                        this.showTab('photo')
                        let photo = this.photos.find((photo) => photo.id == failedMessage.image_id)
                        photo.active = true
                        this.selectedPhotos = [photo.id]
                        break;
                    case 'video':
                        this.showAttachMenu()
                        this.showTab('video')
                        let video = this.videos.find((video) => video.id == failedMessage.video_id)
                        video.active = true
                        this.selectedVideos = [video.id]
                        break;
                    case 'location':
                        this.showAttachMenu()
                        this.showTab('location')
                        break;
                    default:
                        break;
                }
                
            },

            // ###############################################
            // Ancillary methods
            // ###############################################
            handleGesture(str, e) {
                if (str === 'swipeRight') {
                    // Suppress swipe right, do nothing
                    this.$store.dispatch(chatModule.actions.toggleSwipe, false)
                }
            },
            changeScrollBarState(value) {
                this.$emit('changeScrollBarState', value);
            },
            showTab(tab){
                this.tab = tab
                if (tab === 'location') {
                    this.locationTabClick()
                }

                if (typeof tab === 'undefined') {
                  this.changeScrollBarState(true)
                } else {
                  this.changeScrollBarState(false)
                }
            },
            resizeClippingMask(){
                // 100% height and 100% width of parent
                this.mask.widthModifier = $('.w-messages').width() * 0.7 / this.mask.initialWidth
                this.mask.heightModifier = 200 / this.mask.initialHeight
                this.mask.width = this.mask.initialWidth * this.mask.widthModifier
                this.mask.height = this.mask.initialHeight * this.mask.heightModifier
            },
            goToPrevChatPosition(position, iteration = 1) {
                if (iteration++ > 10) {
                    return;
                }

                const hash = document.querySelector('#js-chat-group-cmp');
                if (null === hash) {
                    return
                }

                hash.scrollTop = position;
                setTimeout(() => {
                    this.goToPrevChatPosition(position, iteration);
                }, 50);
            },
            getImagePath(message) {
                let imagePath = message.photo_small
                let path = null
                if (
                    imagePath.substr(0, 11) === '/assets/img'
                    ||
                    imagePath.substr(0, 4) === 'http'
                ){
                    path = imagePath
                } else {
                    path = `/uploads/users/${imagePath}_orig.jpg`
                }
                return path
            },
            isNewDay(index) {
                const msg = this.messages[index];
                const prevMsg = this.messages[index-1];

                return !prevMsg || msg.idate.substr(0, 10) !== prevMsg.idate.substr(0, 10);
            },

            // ###############################################
            // Photo methods
            // ###############################################
            viewPhoto(msg) { //event
                if(!msg){
                  return false;
                }
                app.prevMessageId = msg.id;
                if (this.isMobile) {
                    this.goTo(`/chat-group-photo/${this.eventId}/${msg.id}/${msg.conversation}`);
                } else {
                    app.$emit('show-view-group-chat-photo-reveal', this.eventId, msg)
                }
            },
            choosePhoto() {
                this.$refs.photo.click();
            },
            async sendPhotos() {
                this.tab         = null;

                const photosList = _.pickBy(this.selectedPhotos, value => value); //select photos with value === true
                const photosIds  = _.values(photosList);

                if (photosIds.length) {
                    $('.w-messages').click();

                    let messageHashes             = {},
                        lastHash =  null,
                        conversationUpdatePayload = this.getNewMessagePayload({msg_type: 'image'})


                    photosIds.forEach(function(photoId){
                        // We need temporary hash to match and update this message later
                        let hash  = Math.random().toString(36),
                            photo = this.photos.find((photo) => photo.id == photoId)

                        this.$store.commit(chatModule.mutations.message.push, {
                            eventId: this.eventId,
                            message: _.cloneDeep({
                                ...conversationUpdatePayload.conversation.message,
                                image_id:    parseInt(photoId),
                                photo_small: photo && photo.photo_small,
                                photo_orig:  photo && photo.photo_orig,
                                hash:        hash
                            })
                        })
                        lastHash = hash;
                        messageHashes[photoId] = hash
                    }, this)

                    conversationUpdatePayload.conversation.message.hash = lastHash;
                    this.$store.dispatch(chatModule.actions.conversations.update, conversationUpdatePayload)

                    this.$nextTick(function(){
                        this.scrollToBottom()
                    })

                    try {
                        let response = await axios.post('/api/sendMessage', {
                            eventId: this.eventId,
                            msgType: 'image',
                            channel: 'group',
                            hashes:  messageHashes,
                            photosIds,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                              conversationUpdatePayload.conversation.message.reply_message.id : null,
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data     = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                    eventId:            this.eventId,
                                    conversation:       data.conversation,
                                    isNewUnreadMessage: false,
                                    insertIfMissing:    true
                                });

                                if (data.messages.length) {
                                    data.messages.forEach((responseMessage) => {
                                        let message = {
                                            ...responseMessage,
                                            hash: messageHashes[responseMessage.image_id]
                                        }

                                        this.$store.commit(chatModule.mutations.message.update, {
                                            eventId: this.eventId,
                                            message
                                        })

                                        this.$nextTick(function(){
                                            this.scrollToBottom()
                                        })
                                    }, this)
                                }

                                //remove cached chat images from memory
                                this.$store.commit(chatModule.mutations.messages.deleteImages, {
                                    eventId: this.eventId
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e)
                        photosIds.forEach(function(photoId) {
                            let photo = this.photos.find((photo) => photo.id == photoId)

                            this.$store.commit(chatModule.mutations.message.update, {
                                eventId: this.eventId,
                                message: _.cloneDeep({
                                    ...conversationUpdatePayload.conversation.message,
                                    image_id:    parseInt(photoId),
                                    photo_small: photo && photo.photo_small,
                                    photo_orig:  photo && photo.photo_orig,
                                    hash:        messageHashes[photoId],
                                    id:          messageHashes[photoId],
                                    failed:      true,
                                })
                            })
                        }, this)

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                    
                }

                this.selectedPhotos = []

                this.photos.map(photo => {
                    photo.active = false;
                });

                this.$nextTick(function(){
                    this.afterSend()
                })
            },

            // ###############################################
            // Video methods
            // ###############################################
            chooseVideo() {
                this.$refs.video.click();
            },
            viewVideo(msg) {
              app.prevMessageId = msg.id;
                if (this.isMobile) {
                    this.goTo(`/chat-group-video/${this.eventId}/${msg.id}/${msg.conversation}`);
                } else {
                    app.$emit('show-view-group-chat-video-reveal', this.eventId, msg)
                }
            },
            async sendVideos() {
                this.tab = null;
                const videosList = _.pickBy(this.selectedVideos, value => value); //select videos with value === true
                const videosIds = _.values(videosList);

                if (videosIds.length) {
                    $('.w-messages').click();

                    let messageHashes             = {},
                        lastHash = null,
                        conversationUpdatePayload = this.getNewMessagePayload({msg_type: 'video'})


                    videosIds.forEach(function(videoId){
                        // We need temporary hash to match and update this message later
                        let hash  = Math.random().toString(36),
                            video = this.videos.find((video) => video.id == videoId)

                        this.$store.commit(chatModule.mutations.message.push, {
                            eventId: this.eventId,
                            message: _.cloneDeep({
                                ...conversationUpdatePayload.conversation.message,
                                video_id:      parseInt(videoId),
                                message:       video && video.video_name,
                                hash:          hash,
                                thumbnail_img: (video && video.thumbnail_type === 'img' && video.thumb_small) || null,
                                thumbnail_gif: (video && video.thumbnail_type === 'gif' && video.thumb_small) || null
                            })
                        })

                        messageHashes[videoId] = hash
                        lastHash = hash;
                    }, this)

                  conversationUpdatePayload.conversation.message.hash = lastHash;
                  this.$store.dispatch(chatModule.actions.conversations.update, conversationUpdatePayload)

                    this.$nextTick(function(){
                        this.scrollToBottom()
                    })
                    try {
                        let response = await axios.post('/api/sendMessage', {
                            eventId: this.eventId,
                            msgType: 'video',
                            channel: 'group',
                            hashes:  messageHashes,
                            videosIds,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                              conversationUpdatePayload.conversation.message.reply_message.id : null,
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data     = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                    eventId:            this.eventId,
                                    conversation:       data.conversation,
                                    isNewUnreadMessage: false,
                                    insertIfMissing:    true
                                })

                                if (data.messages.length) {
                                    data.messages.forEach((responseMessage) => {
                                        let message = {
                                            ...responseMessage,
                                            hash: messageHashes[responseMessage.video_id]
                                        }

                                        this.$store.commit(chatModule.mutations.message.update, {
                                            eventId: this.eventId,
                                            message
                                        })

                                        this.$nextTick(function(){
                                            this.scrollToBottom()
                                        })
                                    }, this)
                                }

                                //remove cached chat videos from memory
                                this.$store.commit(chatModule.mutations.messages.deleteVideos, {
                                    eventId: this.eventId
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e)
                        videosIds.forEach(function(videoId){
                            let video = this.videos.find((video) => video.id == videoId)

                            this.$store.commit(chatModule.mutations.message.update, {
                                eventId: this.eventId,
                                message: _.cloneDeep({
                                    ...conversationUpdatePayload.conversation.message,
                                    video_id:      parseInt(videoId),
                                    message:       video && video.video_name,
                                    thumbnail_img: (video && video.thumbnail_type === 'img' && video.thumb_small) || null,
                                    thumbnail_gif: (video && video.thumbnail_type === 'gif' && video.thumb_small) || null,
                                    hash:          messageHashes[videoId],
                                    id:            messageHashes[videoId],
                                    failed:        true,
                                })
                            })
                        }, this)

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                    
                }

                this.selectedVideos = []

                const videos = this.videos;

                videos.forEach(function (elem, index) {
                    elem.active ? elem.active = !elem.active : elem.active;

                    this.$set(videos, index, elem);
                }, this);

                this.$nextTick(function(){
                    this.afterSend();
                })
            },

            // ###############################################
            // Location methods
            // ###############################################
            handleMapMarkerDrag(event) {
                let newLat, newLng;

                if (this.mapProviderIsGmap) {
                    newLat = event.latLng.lat();
                    newLng = event.latLng.lng();
                } else {
                    newLat = event.target.getLatLng().lat;
                    newLng = event.target.getLatLng().lng;
                }

                this.lat = newLat;
                this.lng = newLng;
            },
            handleZoomChanged(event) {
                if (this.mapProviderIsGmap) {
                    this.mapZoom = event;
                } else {
                    this.mapZoom = event.target.getZoom();
                }
            },
            viewLocation(msg) {
                this.locationPreview = msg
                this.locationPreviewVisible = true
            },
            hideLocationPreview() {
                this.locationPreviewVisible = false
                this.locationPreview = null
            },
            locationTabClick() {
                let self = this

                Vue.nextTick(function () {
                    if (self.mapProviderIsGmap) {
                        Vue.$gmapDefaultResizeBus.$emit('resize');
                    } else {
                        self.$refs.geoMap.$refs.osmMap.mapObject.invalidateSize();
                    }
                })

                this.getCurrentPosition()
                    .then(function(pos) {
                        self.lat = pos.lat
                        self.lng = pos.lng
                    });
            },
            async sendLocation() {
                this.tab = null;
                let location = {
                    zoom: this.mapZoom,
                    lat: this.lat,
                    lng: this.lng,
                };

                // We need temporary hash to match and update this message later
                let messageHash = Math.random().toString(36)

                let conversationUpdatePayload = this.getNewMessagePayload({
                    msg_type: 'location',
                    message:  JSON.stringify(location),
                    hash : messageHash
                })

                this.$store.dispatch(chatModule.actions.conversations.update, conversationUpdatePayload)

                this.$store.commit(chatModule.mutations.message.push, {
                    eventId: this.eventId,
                    message: {
                        ...conversationUpdatePayload.conversation.message,
                        hash: messageHash
                    }
                })

                this.$nextTick(function(){
                    this.scrollToBottom()
                })

                try {
                    let response = await axios.post('/api/sendMessage', {
                        eventId: this.eventId,
                        msgType: 'location',
                        channel: 'group',
                        message: JSON.stringify(location),
                        hash:    messageHash,
                        replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                          conversationUpdatePayload.conversation.message.reply_message.id : null,
                    })

                    if (response.status === 200) {
                        let data = response.data

                        this.$store.dispatch(chatModule.actions.conversations.update, {
                            eventId:            this.eventId,
                            conversation:       data.conversation,
                            isNewUnreadMessage: false,
                            insertIfMissing:    true
                        });

                        let message = {...data.conversation.message, hash: messageHash}
                        this.$store.commit(chatModule.mutations.message.update, {
                            eventId: this.eventId,
                            message
                        });

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                } catch (e) {
                    if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                      this.showErrorNotification(e.data.error);
                    }
                    console.error('error', e)
                    this.$store.commit(chatModule.mutations.message.update, {
                        eventId: this.eventId,
                        message: {
                            ...conversationUpdatePayload.conversation.message,
                            hash: messageHash,
                            id: messageHash,
                            failed: true,
                        }
                    })

                    this.$nextTick(function(){
                        this.scrollToBottom()
                    })
                }
                

                $('.messages-box').click();

                this.$nextTick(function(){
                    this.afterSend();
                })
            },

            // ###############################################
            // Delete methods
            // ###############################################
            tryDelete(messageId) {
                if (this.userIsPro || (this.event.type === 'club' && this.event.user_id === this.currentUserId)) {
                    this.deleteMessageId = messageId
                    this.showDeleteAlert()
                } else {
                    this.$store.dispatch('requirementsAlertShow', 'deletemsg')
                }
            },
            showDeleteAlert() {
                this.deleteAlertVisible = true
            },
            hideDeleteAlert() {
                this.deleteAlertVisible = false
            },
            confirmDelete() {
                this.$store.dispatch(chatModule.actions.messages.delete, {
                    eventId: this.eventId,
                    messageId: this.deleteMessageId
                })
                this.hideDeleteAlert()
            },

            // ###############################################
            // Textarea methods
            // ###############################################
            initTextAreaValues(){
                let messageTmp = this.textarea.message
                this.textarea.message = ''
                if(this.$refs.chatMessageTextarea !== undefined){
                  this.textarea.baseScrollHeight = this.$refs.chatMessageTextarea.scrollHeight
                }else{
                  this.textarea.baseScrollHeight = 0;
                }
                this.textarea.message = messageTmp
            },
            resetTextAreaSize(){
                this.textarea.rows = 1
                this.textarea.height = 45
            },
            focusTextArea(){
                this.attachMenuVisible = false
                this.tab = false;
                this.resizeTextArea()
            },
            unfocusTextArea(){
                if (this.textarea.message == '') {
                    this.resetTextAreaSize()
                }
            },
          deleteTextMessage() {
            let storageId = this.chatMode === 'user' ?
                'remember-chat-' + this.userId
                :
                'remember-chat-event-' + this.eventId

            if (storageId) {

              var app = this
              setTimeout(function () {
                var message = app.textarea.message
                localStorage.setItem(storageId, message)
              }, 10)

            }
          },
            resizeTextAreaDebounce: _.debounce(function () {
                this.resizeTextArea();
            }, 100),
            resizeTextArea() {
                let rowsCount = Math.ceil((this.$refs.chatMessageTextarea.scrollHeight - 12 * 2) / 21)
                this.textarea.rows = rowsCount + 1 > 6 ? 6 : rowsCount

                if (!this.isMobile) {
                    this.textarea.height = this.textarea.rows * 21 + 12 * 2
                } else {
                    if (rowsCount === 1) this.textarea.height = null
                    else if (rowsCount === 2) this.textarea.height = 59
                    else if (rowsCount === 3) this.textarea.height = 80
                    else if (rowsCount === 4) this.textarea.height = 101
                    else if (rowsCount === 5) this.textarea.height = 122
                    else if (rowsCount >= 6) this.textarea.height = 143
                }

                let storageId = this.chatMode === 'user' ?
                    'remember-chat-' + this.userId
                    :
                    'remember-chat-event-' + this.eventId

                if (storageId) {
                  var message = this.textarea.message
                  if(localStorage.getItem(storageId) && !message) {
                    message = localStorage.getItem(storageId)
                  }
                  localStorage.setItem(storageId, message)
                }
            },
            afterSend(){
                this.focusMessageField()

                if (app.isDesktop) {
                    this.changeScrollStyle(false, true);
                }

                this.resetTextAreaSize()

                if (app.isDesktop) {
                    this.changeScrollStyle(true, false);
                }

                this.changeScrollBarState(true)
            },
            changeScrollStyle(activeScrollSidebar, disableScroll) {
                this.$emit('changeScrollStyle', activeScrollSidebar, disableScroll);
            },
            focusMessageField(){
              if(this.$refs.chatMessageTextarea && !this.tab) {
                this.$refs.chatMessageTextarea.focus();
              }
            },
            reset(){
                this.$store.commit(chatModule.mutations.messages.set, {
                    eventId: this.eventId,
                    messages: []
                })

                if (this.$refs.infiniteLoadingChat)
                    this.$refs.infiniteLoadingChat.stateChanger.reset()
            },
            markConversationAsRead(){
                this.$store.dispatch(chatModule.actions.conversations.markAsRead, {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatType: 'group',
                    sync: true
                })
            },

            // ###############################################
            // Cache methods
            // ###############################################
            softReload(source){
                // if (this.refreshQueued) {
                    this.reset()
                    // this.refreshQueued = false
                // }
            },
            async softLoad() {
                if (this._inactive) {
                    return;
                }
                let conversationId = this.conversation_id;
                if (!conversationId && this.$store.state.chatModule && this.$store.state.chatModule.conversations) {
                    let conversation = this.$store.state.chatModule.conversations.all.find(c => {
                        return c.chatType === 'group' && c.event && c.event.id === this.eventId;
                    });
                    if (conversation) {
                        conversationId = conversation.conversation_id || conversation.id;
                    }
                }
                if (!conversationId) {
                    return;
                }
                try {
                    let response = await axios.get(`/api/getConversationMessages/${conversationId}?limit=30`);
                    if (response.status === 200 && response.data && response.data.data) {
                        let messages = _.toArray(response.data.data);
                        let prevCount = this.messages ? this.messages.length : 0;
                        messages.reverse().forEach((msg) => {
                            this.$store.commit(chatModule.mutations.message.push, {
                                userId: null,
                                eventId: this.eventId,
                                message: msg
                            });
                        });
                        this.markConversationAsRead();
                        if (this.messages && this.messages.length > prevCount) {
                            this.$nextTick(() => {
                                this.scrollToBottom();
                            });
                        }
                    }
                } catch (e) {
                    console.error('[GroupChatComponent] Soft load error', e);
                }
            },
            invalidate(){
                this.refreshQueued = true
                this.page = 0
                this.softReload()
            },
            checkScroll(event) {
                let eventTarget = event.target;

                if(eventTarget.classList.contains('send-media-inner')
                    || eventTarget.classList.contains('handles-list-container')){
                  return false;
                }
                let currentScroll = eventTarget.scrollTop;
                let scrollHeight = eventTarget.scrollHeight;
                let clientHeight = eventTarget.clientHeight;
                this.showScrollBottom = currentScroll + clientHeight <= scrollHeight - 700;

            },
            textAreaFocus() {
                document.getElementById('text__field').focus();
            }
        },
        watch: {
            attachMenuVisible: {
              immediate: true,
              handler: function(newValue, oldValue){
                if(newValue){
                  this.closeHandlesList();
                }
              }
            },
            entitiesLoaded: {
                immediate: true,
                handler: function(newValue, oldValue){
                    if (newValue && newValue !== oldValue) {
                        this.$nextTick(function(){
                            this.init()
                        })
                    }
                }
            },
            refreshQueued: {
                immediate: true,
                handler(value) {
                    console.log('[GroupChatComponent] Watcher refreshQueued', { value })
                    if (value && !this._inactive) {
                        this.reset()
                        this.refreshQueued = false
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
              userHasNewMessages: 'userHasNewMessages',
            }),
            clipboardImageUrl(){
              return window.URL.createObjectURL(this.clipboardImage)
            },
            replyExists(){
              return this.$store.getters[chatModule.getters.replies.get](this.chatMode,this.userId,this.eventId)
            },
            mapStyles() {
              if (app.isDesktop) {
                return "width: 100%;";
              } else {
                return "width: 100%; min-width: 70vw";
              }
            },
            entitiesLoaded(){
                /*console.log('entitiesLoaded', {
                    chatMode: this.chatMode,
                    user: this.user,
                    event: this.event,
                })*/

                if (
                    !!this.eventId
                    &&
                    this.event !== null
                ) {
                    return true
                }

                return false
            },
            event(){
                if (!this.eventId || !this.chatMode)
                    return null
                return this.$store.getters.getEvent(this.eventId)
            },
            ...mapState({
                messages: function(state) {
                    return state.chatModule.chat.event.messages[this.eventId] || [];
                },
                currentUser: 'profile',
                photos: 'profilePhotos',
                videos: 'profileVideos',
            }),
            userLoading() {
                let loading = !this.currentUser || !this.currentUser.lng;
                //on user info loaded -> update marker
                if(!loading) {
                    this.lat = parseFloat(this.currentUser.lat);
                    this.lng = parseFloat(this.currentUser.lng);
                }

                return loading;
            },
        },
        mounted() {
            console.log('[GroupChatComponent] mounted', {
                userId: this.userId,
                eventId: this.eventId,
                chatMode: this.chatMode,
            })

            this.$store.commit(chatModule.mutations.messages.set, {
                userId: this.userId,
                eventId: this.eventId,
                messages: []
            })

            let container;

            if (app.isMobile) {
                container = document.getElementById('application-wrapper');
            } else {
                container = document.getElementById(`conversation-group-scroll`);
            }

            container.addEventListener('scroll', this.checkScroll, true);

            this.$refs.infiniteLoadingChat.stateChanger.reset();
            
            this.textAreaFocus();

            if (!this.entitiesLoaded) {
                return
            }

            this.markConversationAsRead()

            app.$on('soft-load-messages', this.softLoad)
            app.$on('invalidate-messages', this.invalidate)
        },
        activated() {
            console.log('[GroupChatComponent] Activated')

            let container;
            this.$nextTick(() => {
                if (app.isMobile) {
                    container = document.getElementById('application-wrapper');
                } else {
                    container = document.getElementById('conversation-group-scroll');
                }

                container.addEventListener('scroll', this.checkScroll, true);
            });

            this.$refs.infiniteLoadingChat.stateChanger.reset();

            this.textAreaFocus();
            this.markConversationAsRead();

            if(app.isMobile){
              if(app.prevMessageId !== null){
                const scrollElement = this.$el.querySelector('#msg-'+app.prevMessageId);
                if(scrollElement){
                  this.$nextTick(() => {
                    scrollElement.scrollIntoView({block: "center"})
                  });
                }
              }else{
                this.scrollToBottom();
              }
            }
            //this.softReload('Chat')
            app.$off('soft-load-messages', this.softLoad)
            app.$off('invalidate-messages', this.invalidate)
            app.$on('soft-load-messages', this.softLoad)
            app.$on('invalidate-messages', this.invalidate)
        },
        deactivated() {
          console.log('[GroupChatComponent] Deactivated')
          this.selectedPhotos = [];
          this.photos.map(photo => {
            photo.active = false;
          });
          if(this.$refs.contextMenu){
            this.$refs.contextMenu.hideMenu();
          }
          this.selected_message = false;
          if(this.scrollInterval){
            clearInterval(this.scrollInterval)
          }
          app.$off('soft-load-messages', this.softLoad)
          app.$off('invalidate-messages', this.invalidate)
        },
        created() {
            if (this.$refs.infiniteLoadingChat) {
                this.$refs.infiniteLoadingChat.stateChanger.reset();
            }
        },
        destroyed() {
            this.showTab()
            app.$off('soft-load-messages', this.softLoad)
            app.$off('invalidate-messages', this.invalidate)
            if(this.$refs.contextMenu){
              this.$refs.contextMenu.hideMenu();
            }
            this.selected_message = false;
            if(this.scrollInterval){
              clearInterval(this.scrollInterval)
            }
        }
    }
</script>
